import { Button, ButtonProps } from '../../controls';

export default function DialogButton({
  children,
  title,
  size = 'small',
  variant = 'text',
  type,
  id,
  ...rest
}: DialogButtonProps) {
  const actualType = type || id === 'cancel' ? 'secondary' : 'primary';

  return (
    <Button size={size} type={actualType} variant={variant} {...rest}>
      {title}
      {children}
    </Button>
  );
}

export type DialogButtonProps = ButtonProps;
